import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterComponent } from './register/register.component';
import { LoginComponent } from './login/login.component';
import { MaterialModule } from '../material/material.module';
import { SharedModule } from '../shared/shared.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SecurityService } from './security.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { CustomerProfileComponent } from './customer-profile/customer-profile.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

@NgModule({
    declarations: [RegisterComponent, LoginComponent, ForgotPasswordComponent, CustomerProfileComponent, VerifyEmailComponent, ResetPasswordComponent],
    exports: [
        LoginComponent,
        RegisterComponent,
        CustomerProfileComponent,
        VerifyEmailComponent
    ], imports: [CommonModule,
        RouterModule,
        MaterialModule,
        SharedModule,
        FormsModule, ReactiveFormsModule], providers: [SecurityService, provideHttpClient(withInterceptorsFromDi())]
})
export class SecurityModule { }
